// import React from "react";
// import { Link } from "react-router-dom";
// import { motion } from "framer-motion";
// import { useEffect, useRef } from "react";


// /* ================= IMAGES ================= */
// import banner1 from "../../images/banner_bg_7.jpg";
// import banner2 from "../../images/banner_bg_8.jpg";
// import banner3 from "../../images/banner_bg_9.jpg";

// import { useTranslation } from "react-i18next";

// /* ================= DATA ================= */
// const ADD_BANNERS = [
//   {
//     id: 1,
//     titleKey: "offer_banner_1_title",
//     descKey: "offer_banner_1_desc",
//     image: banner1,
//   },
//   {
//     id: 2,
//     titleKey: "offer_banner_2_title",
//     descKey: "offer_banner_2_desc",
//     image: banner2,
//   },
//   {
//     id: 3,
//     titleKey: "offer_banner_3_title",
//     descKey: "offer_banner_3_desc",
//     image: banner3,
//   },
// ];

// /* ================= COMPONENT ================= */
// const OffersBanner = () => {

//   const { t, i18n } = useTranslation();
//   const isArabic = i18n.language === "ar";
//   return (

//     <section className="add_banner_3   xs_pt_55" dir={isArabic ? "rtl" : "ltr"}>
//       <div className="container">
//         <div className="row">

//           {ADD_BANNERS.map((item) => (
//             <div className="col-xl-4 col-md-6 mb-4" key={item.id}>

//              <div
//                 className="mm-add-banner"
//                 style={{ backgroundImage: `url(${item.image})` }}
//               >
//                 <div className="mm-banner-overlay"></div>

//                 <div className="mm-banner-content">
//                   <span className="mm-badge">{t("limited_offer")}</span>
//                     <h3>{t(item.titleKey)}</h3>
//                     <p>{t(item.descKey)}</p>

//                   <Link to="/CategorieList" className="mm-banner-btn">
//                     {t("explore_now")} →
//                   </Link>
//                 </div>
//               </div>


//             </div>
//           ))}

//         </div>
//       </div>
//     </section>

//   );
// };

// export default OffersBanner;


import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

/* ================= IMAGES ================= */
import banner1 from "../../images/banner_bg_7.jpg";
import banner2 from "../../images/banner_bg_8.jpg";
import banner3 from "../../images/banner_bg_9.jpg";

/* ================= DATA ================= */
const ADD_BANNERS = [
  {
    id: 1,
    title: "addbanner.title1",
    desc: "addbanner.desc1",
    image: banner1,
    link: "/offer-products?banner=1"
  },
  {
    id: 2,
    title: "addbanner.title2",
    desc: "addbanner.desc2",
    image: banner2,
    link: "/offer-products?banner=2"
  },
  {
    id: 3,
    title: "addbanner.title3",
    desc: "addbanner.desc3",
    image: banner3,
    link: "/offer-products?banner=3"
  },
];

/* ================= COMPONENT ================= */
const AddBannerSection = () => {
  const { t } = useTranslation();

  return (
    <section className="add_banner_3 xs_pt_55">
      <div className="container">
        <div className="row">

          {ADD_BANNERS.map((item) => (
            <div className="col-xl-4 col-md-6 mb-4" key={item.id}>

              {/* SAME OLD UI CLASS NAMES */}
              <div
                className="mm-add-banner"
                style={{
                  backgroundImage: `url(${item.image})`,
                }}
              >
                <div className="mm-banner-overlay"></div>

                <div className="mm-banner-content">

                  <span className="mm-badge">
                    {t("addbanner.badge")}
                  </span>

                  <h3>{t(item.title)}</h3>

                  <p>{t(item.desc)}</p>

                  <Link
                    // to="/CategorieList"
                    to={item.link}
                    className="mm-banner-btn"
                  >
                    {t("addbanner.cta")}
                  </Link>

                </div>
              </div>

            </div>
          ))}

        </div>
      </div>
    </section>
  );
};

export default AddBannerSection;